import { z } from 'zod';

/**
 * M7 — Responder.
 *
 * ── La forma del envío ──
 * Se manda **todo el cuestionario de una vez**, no pregunta por pregunta. Un
 * envío parcial guardado dejaría respuestas a medias que los agregados de M8
 * contarían como opiniones — y una respuesta es un hecho: existe completa o no
 * existe. El teléfono guarda el avance EN MEMORIA mientras la persona navega;
 * la base solo conoce el envío final.
 *
 * Cada elemento apunta a su pregunta; la matriz manda un elemento POR
 * AFIRMACIÓN (`itemId`), y la selección múltiple un elemento POR OPCIÓN
 * marcada (`opcionId`). El servidor valida contra la versión congelada — esto
 * de acá solo garantiza la forma.
 */

export const esquemaValorRespuesta = z
  .object({
    preguntaId: z.number().int().positive(),
    /** La afirmación de una matriz. */
    itemId: z.number().int().positive().optional(),
    /** La opción elegida en una selección. */
    opcionId: z.number().int().positive().optional(),
    punto: z.number().int().positive().optional(),
    valorBool: z.boolean().optional(),
    texto: z.string().trim().min(1).max(5000).optional(),
    numero: z.number().int().optional(),
    /** aaaa-mm-dd. */
    fecha: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/, 'La fecha va como aaaa-mm-dd.')
      .optional(),
  })
  .refine(
    (v) =>
      [v.opcionId, v.punto, v.valorBool, v.texto, v.numero, v.fecha].filter(
        (x) => x !== undefined,
      ).length === 1,
    'Cada elemento lleva exactamente un valor.',
  );
export type ValorRespuesta = z.infer<typeof esquemaValorRespuesta>;

export const esquemaEnviarRespuestas = z.object({
  respuestas: z.array(esquemaValorRespuesta).min(1).max(1000),
});
export type EntradaEnviarRespuestas = z.infer<typeof esquemaEnviarRespuestas>;

export const esquemaRespuestaEnviada = z.object({
  enviadoEn: z.string(),
});
export type RespuestaEnviada = z.infer<typeof esquemaRespuestaEnviada>;
